import { getters } from "@/constants/state";

export default {
  [getters.AVAILABLES_USER_AVAILABLES_GETTER]: (state) => state.userAvailables,
};
